import React, { Component, Fragment } from 'react'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import { thousandSeparator } from '../../utils/Utils'
import { Rub } from '../app-icon/Icons'
import MChart from './MChart'
import MBarChart from './MBarChart'
import SwipeableViews from 'react-swipeable-views'
import MTabs from './MTabs'

class Daily extends Component {
  state = {
    valueTab: 0,
  }

  handleChangeTab = (event, valueTab) => {
    this.setState({ valueTab })
  }

  handleChangeIndex = index => {
    this.setState({ valueTab: index })
  }

  render() {
    const {
      classes,
      theme,
      data: { summary, conversions, orders, leads, calls,  currency},
    } = this.props

    const { valueTab } = this.state

    const chartsSummaryGrid = () =>
      summary.map(({ alias, total, chartByDaysData }, index) => {
        const title = () => {
          switch (alias) {
            case 'cost':
              return 'Расходы на рекламу'
            case 'impressions':
              return 'Число показов'
            case 'sessions':
              return 'Сеансы'
            case 'cpc':
              return 'CPC'
            default:
              return
          }
        }

        return (
          <div className={classes.gridSmallItem} key={alias}>
            <div className={classes.brick}>
              <div className={classes.brickTitle}>{title()}</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(total)}
                {index === 0 || index === 3 ? (
                  currency
                ) : null}
              </div>
              <div className={classes.chartBox}>
                <MChart
                  label={title()}
                  data={chartByDaysData}
                  showGridline
                  fill
                  showGridline
                  gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                  zeroLineColor={'#979797'}
                  fontColor={'#000000'}
                  chartColor={'#8866ff'}
                  symbol={index === 0 || index === 3 ? currency : ''}
                  chartColorFill={'rgba(136, 102, 255, 0.2)'}
                  verticalLineColor={'#8866ff'}
                />
              </div>
            </div>
          </div>
        )
      })

    const bookMarks = () => {
      return conversions.map(({ alias, name, total }, index) => {
        const label = (
          <span>
            <span className={classes.conversionTitle}>{name}</span>
            <span className={classes.conversionTotal}>{total}</span>
          </span>
        )

        return (
          <Tab
            key={index}
            label={label}
            classes={{
              root: classes.tabConversion,
            }}
          />
        )
      })
    }

    const bookMarksContainer = () => {
      return conversions.map(({ alias, name, chartByDaysData }, index) => {
        return (
          <TabContainer key={index} dir={theme.direction}>
            <MChart
              label={name}
              data={chartByDaysData}
              showGridline
              gridLinesColor={'rgba(0, 0, 0, 0.2)'}
              zeroLineColor={'#979797'}
              fontColor={'#000000'}
              chartColor={'#8866ff'}
              chartColorFill={'rgba(136, 102, 255, 0.2)'}
            />
          </TabContainer>
        )
      })
    }

    const leadsTabs = () => {
      return leads.map(({ name, data, chartBySourcesData }) => {
        const tabs = data.map(({ alias, total }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return currency
              default:
                return
            }
          }

          const label = (
            <span>
              <span className={classes.conversionTitle}>{tabName()}</span>
              <span className={classes.conversionTotal}>
                {thousandSeparator(total)}
                {symbol()}
              </span>
            </span>
          )

          return <Tab key={alias} label={label} />
        })

        const container = data.map(({ alias, chartByPeriodData }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return currency
              default:
                return
            }
          }

          return (
            <TabContainer key={alias} dir={theme.direction}>
              <MChart
                label={tabName()}
                data={chartByPeriodData}
                showGridline
                gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                zeroLineColor={'#979797'}
                fontColor={'#000000'}
                chartColor={'#8866ff'}
                chartColorFill={'rgba(136, 102, 255, 0.2)'}
                symbol={symbol()}
              />
            </TabContainer>
          )
        })

        return (
          <div key={name} className={classes.rowCharts}>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Заявки'}
                </div>
                <MTabs tabs={tabs} container={container} />
              </div>
            </div>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Заявки'}
                </div>
                <div className={classes.chartBox} style={{ marginTop: 0 }}>
                  {chartBySourcesData && chartBySourcesData.length > 0 ? (
                    <MBarChart
                      label={name ? name : 'Заявки'}
                      data={chartBySourcesData}
                      showGridline
                      showLegend
                      gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                      zeroLineColor={'#979797'}
                      fontColor={'#000000'}
                      limitTicks={7}
                    />
                  ) : (
                    <span className={classes.noData}>Нет данных</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      })
    }

    const callsTabs = () => {
      return calls.map(({ name, data, chartBySourcesData }) => {
        const tabs = data.map(({ alias, total }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return currency
              default:
                return
            }
          }

          const label = (
            <span>
              <span className={classes.conversionTitle}>{tabName()}</span>
              <span className={classes.conversionTotal}>
                {thousandSeparator(total)}
                {symbol()}
              </span>
            </span>
          )

          return <Tab key={index} label={label} />
        })

        const container = data.map(({ alias, chartByPeriodData }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return currency
              default:
                return
            }
          }

          return (
            <TabContainer key={alias} dir={theme.direction}>
              <MChart
                label={tabName()}
                data={chartByPeriodData}
                showGridline
                gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                zeroLineColor={'#979797'}
                fontColor={'#000000'}
                chartColor={'#8866ff'}
                chartColorFill={'rgba(136, 102, 255, 0.2)'}
                symbol={symbol()}
              />
            </TabContainer>
          )
        })

        return (
          <div key={name} className={classes.rowCharts}>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Звонки'}
                </div>
                <MTabs tabs={tabs} container={container} />
              </div>
            </div>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Звонки'}
                </div>
                <div className={classes.chartBox} style={{ marginTop: 0 }}>
                  {chartBySourcesData && chartBySourcesData.length > 0 ? (
                    <MBarChart
                      label={name ? name : 'Звонки'}
                      data={chartBySourcesData}
                      showGridline
                      showLegend
                      gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                      zeroLineColor={'#979797'}
                      fontColor={'#000000'}
                      limitTicks={7}
                    />
                  ) : (
                    <span className={classes.noData}>Нет данных</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      })
    }

    return (
      <div className={classes.grid}>
        {summary && summary.length > 0 && chartsSummaryGrid()}

        {conversions && conversions.length > 0 && (
          <div className={classes.gridFullItem}>
            <div className={classes.brick}>
              <div className={classes.brickTitleBig}>Конверсии</div>
              <AppBar position="static" color="inherit" elevation={0}>
                <Tabs
                  value={valueTab}
                  onChange={this.handleChangeTab}
                  indicatorColor="secondary"
                  textColor="inherit"
                  variant="scrollable"
                  scrollButtons="off"
                  classes={{
                    root: classes.tabsRoot,
                    indicator: classes.tabsIndicator,
                    flexContainer: classes.tabsFlexContainer,
                  }}
                >
                  {bookMarks()}
                </Tabs>
              </AppBar>
              <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={valueTab}
                onChangeIndex={this.handleChangeIndex}
                slideClassName={classes.tabSlide}
                containerStyle={{
                  height: '100%',
                }}
                style={{
                  top: 160,
                  left: 10,
                  right: 20,
                  bottom: 15,
                  position: 'absolute',
                }}
              >
                {bookMarksContainer()}
              </SwipeableViews>
            </div>
          </div>
        )}

        {orders && orders.length > 0 && (
          <Fragment>
            <div className={classes.rowTitle}>
              <div className={classes.brickTitleBig}>Продажи</div>
            </div>
            <div className={classes.gridSmallItem}>
              <div
                className={classes.brick}
                style={{
                  paddingBottom: '23.25%',
                  backgroundColor: '#8866ff',
                }}
              >
                <div className={classes.brickDescription}>
                  <div className={classes.brickTitle} style={{ color: '#fff' }}>
                    Оплаты
                  </div>
                  <div
                    className={classes.brickTotal}
                    style={{ fontSize: 33, color: '#fff' }}
                  >
                    {thousandSeparator(orders[0].total)}
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.gridSmallItem}>
              <div
                className={classes.brick}
                style={{
                  paddingBottom: '23.25%',
                  backgroundColor: '#8866ff',
                }}
              >
                <div className={classes.brickDescription}>
                  <div className={classes.brickTitle} style={{ color: '#fff' }}>
                    Выручка
                  </div>
                  <div
                    className={classes.brickTotal}
                    style={{ fontSize: 33, color: '#fff' }}
                  >
                    {thousandSeparator(orders[0].revenue)}
                    {currency}
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.gridSmallItem}>
              <div
                className={classes.brick}
                style={{
                  paddingBottom: '23.25%',
                  backgroundColor: '#8866ff',
                }}
              >
                <div className={classes.brickDescription}>
                  <div className={classes.brickTitle} style={{ color: '#fff' }}>
                    CPO
                  </div>
                  <div
                    className={classes.brickTotal}
                    style={{ fontSize: 33, color: '#fff' }}
                  >
                    {thousandSeparator(orders[0].cpo)}
                    {currency}
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.gridSmallItem}>
              <div
                className={classes.brick}
                style={{
                  paddingBottom: '23.25%',
                  backgroundColor: '#8866ff',
                }}
              >
                <div className={classes.brickDescription}>
                  <div className={classes.brickTitle} style={{ color: '#fff' }}>
                    ROMI
                  </div>
                  <div
                    className={classes.brickTotal}
                    style={{ fontSize: 33, color: '#fff' }}
                  >
                    {thousandSeparator(orders[0].romi)} %
                  </div>
                </div>
              </div>
            </div>
            <div key={name} className={classes.rowCharts}>
              <div className={classes.gridLargeItem}>
                <div
                  className={classes.brick}
                  style={{
                    backgroundColor: '#8866ff',
                  }}
                >
                  <div className={classes.brickTitle} style={{ color: '#fff' }}>
                    {orders[0].name ? orders[0].name : 'Продажи'}
                  </div>
                  <div className={classes.chartBox} style={{ marginTop: 0 }}>
                    <MChart
                      label={orders[0].name ? orders[0].name : 'Продажи'}
                      data={orders[0].chartByPeriodData}
                      showGridline
                      showLegend={false}
                      fill
                      gridLinesColor={'#ffffff'}
                      zeroLineColor={'#ffffff'}
                      fontColor={'#ffffff'}
                      chartColor={'#ffcc00'}
                      labelFontColor={'#ffffff'}
                      chartColorFill={'rgba(255, 204, 0, 0.2)'}
                      verticalLineColor={'#ffcc00'}
                    />
                  </div>
                </div>
              </div>
              <div className={classes.gridLargeItem}>
                <div
                  className={classes.brick}
                  style={{
                    backgroundColor: '#8866ff',
                  }}
                >
                  <div className={classes.brickTitle} style={{ color: '#fff' }}>
                    {orders[0].name ? orders[0].name : 'Продажи'}
                  </div>
                  <div className={classes.chartBox} style={{ marginTop: 0 }}>
                    {orders[0].chartBySourcesData &&
                    orders[0].chartBySourcesData.length > 0 ? (
                      <MBarChart
                        label={orders[0].name ? orders[0].name : 'Продажи'}
                        data={orders[0].chartBySourcesData}
                        showGridline
                        showLegend
                        fill={false}
                        gridLinesColor={'#ffffff'}
                        zeroLineColor={'#ffffff'}
                        fontColor={'#ffffff'}
                        chartColor={'#ffcc00'}
                        labelFontColor={'#ffffff'}
                        chartColorFill={'#ffcc00'}
                        limitTicks={7}
                      />
                    ) : (
                      <span
                        className={classes.noData}
                        style={{ color: '#fff' }}
                      >
                        Нет данных
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}

        {leads && leads.length > 0 && (
          <Fragment>
            <div className={classes.rowTitle}>
              <div className={classes.brickTitleBig}>Заявки</div>
            </div>

            {leads && leads.length > 0 && leadsTabs()}
          </Fragment>
        )}

        {calls && calls.length > 0 && (
          <Fragment>
            <div className={classes.rowTitle}>
              <div className={classes.brickTitleBig}>Звонки</div>
            </div>

            {calls && calls.length > 0 && callsTabs()}
          </Fragment>
        )}
      </div>
    )
  }
}

function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{ height: '100%', position: 'relative' }}
    >
      {children}
    </Typography>
  )
}

const styles = theme => ({
  grid: {
    margin: '0 5px',
    padding: '85px 0 50px 0',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  gridLargeItem: {
    width: '50%',
    display: 'flex',
    padding: 5,
    position: 'relative',
    '& $brick': {
      padding: '16px 5px 12px 5px',
      width: '100%',
      height: 0,
      paddingBottom: '37.25%',
    },
  },
  gridFullItem: {
    display: 'flex',
    width: '100%',
    minWidth: 305,
    padding: '5px',
    '& $brick': {
      width: '100%',
      height: 0,
      paddingBottom: '28%',
    },
  },
  gridSmallItem: {
    display: 'flex',
    width: '25%',
    minWidth: 305,
    padding: '5px',
    '& $brick': {
      width: '100%',
      height: 0,
      paddingBottom: '68%',
    },
  },
  brick: {
    position: 'relative',
    padding: '20px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    flex: '1 1 auto',
  },
  brickTitle: {
    fontSize: 16,
  },
  brickTitleBig: {
    textAlign: 'center',
    fontSize: 20,
  },
  brickTotal: {
    fontSize: '23px',
    whiteSpace: 'nowrap',
  },
  chartBox: {
    marginTop: 35,
    position: 'absolute',
    left: 10,
    right: 20,
    top: 50,
    bottom: 15,
  },
  tabsRoot: {
    marginTop: 10,
  },
  tabsFlexContainer: {
    justifyContent: 'center',
  },
  tabConversion: {
    minWidth: 'auto',
  },
  rowTitle: {
    width: '100%',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    backgroundColor: '#fff',
    margin: 5,
    padding: 20,
  },
  rowCharts: {
    width: '100%',
    display: 'flex',
    '& $brick': {
      paddingBottom: '52%',
    },
    '& $chartBox': {
      marginTop: 85,
    },
  },
  noData: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -100%)',
    fontSize: 40,
    color: 'rgba(0, 0, 0, 0.4)',
  },
  conversionTitle: {
    display: 'block',
    whiteSpace: 'nowrap',
    textTransform: 'none',
  },
  conversionTotal: {
    display: 'block',
    fontSize: 23,
    lineHeight: 1.2,
  },
})

export default withStyles(styles, { withTheme: true })(Daily)
